import { render, staticRenderFns } from "./BusinessTypeForm.vue?vue&type=template&id=a82cbfce&"
import script from "./BusinessTypeForm.vue?vue&type=script&lang=js&"
export * from "./BusinessTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports